// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2zaQA","requiredAsterisk":"Info_requiredAsterisk__eFHxW"};